import React from 'react';
import axios from "../../../../containers/api";
import {Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, ModalFooter, Alert} from "reactstrap";
import {Table} from "../../../../components/table/Table";
import {Colxx, Separator} from "../../../../components/common/CustomBootstrap";
import AddLoadHall from "./components/AddLoadHall";
import { showCatchError, toEnglishNumbers } from "../../../../helpers/Utils";
import ShowTransportationCompanyHalls from "./components/ShowTransportationCompanyHalls";
import ChangePassModal from "../../../user/components/ChangePassModal";
import DriverTurnModal from"../../../app/loadhall-setting-pages/driver-turn/DriverTurn";
import DriverCityNativeModal from"../../../app/loadhall-setting-pages/driver-native/DriverCityNative";
//import LoadHallLoadHourLimit from "../../../../components/admin/LoadHallLoadHourLimit";
 

class LoadHalls extends React.Component {
    state = {
        LoadHalls: null,
        TransportationCompanies: [],
        LoadHallToEdit: null,
        showTransportationCompaniesModal: false,
        showCustomerModal: false,
        EditModal: false,
        AddModal: false,
        ShowLoadHallLoadHourLimit: false,
        showAddLoadHallModal: false,
        showNewMemberModal: false,
        ChangePassModal: false,
        DriverTurnModal: false,
        DriverCityNativeModal: false,
        LoadHallId: null,
        SaveType: 'Add',
        UserName: null
    };

    componentDidMount() {
        //console.log('tests')
        //this.AccessIsAdmin();
        this.GetLoadHall();
    }

    AccessIsAdmin = () => {
        this.props.showSpinner();
        axios.get('/api/v1/users/GetAccessIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) {
                    this.GetLoadHall();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetLoadHall = () => {
        this.props.showSpinner();
        axios.get('/api/v1/load-halls')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ LoadHalls: res.data.data });
                
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    getTransportationCompanies = () => {
        this.props.showSpinner();
        axios.get('/api/v1/transportation-companies/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({TransportationCompanies: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    createMembershipForLoadHall = (loadHallId) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('/api/v1/load-halls/CreateLoadHallUser?loadHallId=' + loadHallId )
            .then((res) => {
                if(res.data.data!== null)
                {
                this.props.hideSpinner();
                this.props.showAlert("حساب کاربری با موفقیت ساخته شد", "success");
                this.setState({
                    newMemberUsername: res.data.data.userName,
                    newMemberPassword: res.data.data.password,
                    showNewMemberModal: true
                });
                this.GetLoadHall();
            }
            else
            {
                this.props.hideSpinner();
                this.props.showAlert(res.data.errors, 'error'); 
            }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    //changePassword = (username) => {
    //    this.props.closeSweetAlert();
    //    if (username === null || username === '') {
    //        this.props.showAlert('نام کاربری معتبر نمی باشد.', 'error');
    //        return;
    //    }
    //    let model = {
    //        Username: toEnglishNumbers(this.state.username),
    //        Password: toEnglishNumbers(this.state.password),
    //    }
    //    this.props.showSpinner();
    //    axios.post('/api/v1/users/admin-change-pass', model)
            
    //        .then((res) => {
    //            this.props.hideSpinner();
    //            this.props.showAlert("رمز عبور با موفقیت تغییر کرد", "success");
    //            this.setState({
    //                newMemberUsername: res.data.username,
    //                newMemberPassword: res.data.password,
    //                showNewMemberModal: true
    //            });
    //        })
    //        .catch((error) => {
    //            this.props.hideSpinner();
    //            console.log(error.response);
    //            this.props.showAlert(showCatchError(error), "error");
    //        });
    //};

    openModal = (modalName, item) => {
        if (modalName === "showTransportationCompaniesModal") {
            if (this.state.TransportationCompanies.length === 0) {
                this.getTransportationCompanies();
            }
            this.setState({
                [modalName]: true,
                LoadHallToEdit: item
            });
        }
        else if (modalName === "ChangePassModal")
        {
            this.setState({
                [modalName]: true,
                UserName: "LoadHall" + item.loadHallId
            });
        } else if (modalName === "DriverTurnModal")
        {
            this.setState({
                [modalName]: true,
                LoadHallId:   item.loadHallId
            });
        }
        else if (modalName === "DriverCityNativeModal")
        {
            this.setState({
                [modalName]: true,
                LoadHallId:   item.loadHallId
            });
        }
        else {
            this.setState({
                [modalName]: true
            });
        }
    }

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        this.GetLoadHall();
    };
    lastbill = (id) => {
       
        this.props.closeSweetAlert();
        this.props.showSpinner(); 
        axios.patch(`/api/v1/driver-turns/GetBillByDriverNationalId/${id}`)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) {
                    this.props.showAlert(res.data.message, "success");
                }
                else {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.errors, 'error');
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>مدیریت سالن‌ها</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                     <Button outline color="primary" className="mx-3"
                                        onClick={() => this.setState({ AddModal: true, SaveType:'Add' })}>
                                        افزودن سالن جدید
                                    </Button> 
                                </div>

                                <Table
                                    tableHeaders={[
                                        "نام",
                                        "نام کاربری",
                                        "شماره تماس",
                                        "ویرایش",
                                        "نمایندگی‌ها", 
                                        "حساب کاربری",
                                        "رمز عبور",
                                        "نوبت دهي",
                                        "افزودن راننده",
                                        "چک بارنامه",
                                        
                                    ]}

                                    tableRow={this.state.LoadHalls !== null ? this.state.LoadHalls : []}

                                    tableData={[
                                        LoadHall => {
                                            return LoadHall.name;
                                        },
                                        LoadHall => {
                                            return "LoadHall"+LoadHall.loadHallId;
                                        },
                                        LoadHall => {
                                            return LoadHall.tel;
                                        },
                                        LoadHall => {
                                            return (
                                                <Button outline color="info" size="sm"
                                                        onClick={() => this.setState({LoadHallToEdit: LoadHall,
                                                            SaveType:'Edit'
                                                            , AddModal: true})}>
                                                    ویرایش
                                                </Button>
                                            )
                                        },
                                        LoadHall => {
                                            return (
                                                <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("showTransportationCompaniesModal", LoadHall)}>
                                                    شرکت های حمل و نقل
                                                </Button>
                                            )
                                        },
                                      
                                        LoadHall => {
                                            return (
                                                <Button outline color="success" size="sm"
                                                        onClick={() => this.props.showSweetAlert("آیا حساب کاربری برای این سالن ساخته شود؟", "", "success", () => this.createMembershipForLoadHall(LoadHall.loadHallId))}>
                                                    ساختن
                                                </Button>
                                            )
                                        },
                                        LoadHall => {
                                            return (
                                               
                                                  <Button outline color="primary" size="sm"
                                                        onClick={() => this.openModal("ChangePassModal", LoadHall)}>
                                                    تغییر رمز
                                                </Button>
                                            )
                                        },
                                        LoadHall => {
                                            return (

                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.openModal("DriverTurnModal", LoadHall)}>
                                                   نوبت دهي
                                                </Button>
                                            )
                                        },
                                        LoadHall => {
                                            return (

                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.openModal("DriverCityNativeModal", LoadHall)}>
                                                   افزودن راننده
                                                </Button>
                                            )
                                        },
                                        LoadHall => {
                                            return (
                                               
                                                <Button outline color="danger" size="sm"
                                                    onClick={() => this.props.showSweetAlert("آیا از ابطال نوبت در صورت وجود بارنامه در 24 ساعت گذشته مطمئن هستید؟", "", "danger", () => this.lastbill(LoadHall.loadHallId))}>
                                                    چک بارنامه
                                                </Button>

                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>


                <Modal isOpen={this.state.AddModal} size="xlg" toggle={() => this.setState({AddModal: false})}>
                    <ModalHeader toggle={() => this.setState({AddModal: false})}>
                        افزودن سالن جدید
                    </ModalHeader>
                    <ModalBody>
                        <AddLoadHall
                            LoadHallToEdit={this.state.LoadHallToEdit}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                            SaveType={this.state.SaveType}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({AddModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                 

                <Modal isOpen={this.state.showTransportationCompaniesModal} size="xlg" toggle={() => this.setState({showTransportationCompaniesModal: false})}>
                    <ModalHeader toggle={() => this.setState({showTransportationCompaniesModal: false})}>
                        نمایندگی‌ها
                    </ModalHeader>
                    <ModalBody>
                        <ShowTransportationCompanyHalls
                            LoadHallToEdit={this.state.LoadHallToEdit}
                            TransportationCompanies={this.state.TransportationCompanies}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.setState({showTransportationCompaniesModal: false})}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>

                

                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                    <ModalHeader toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <Alert color="danger">
                            توجه! لطفا اطلاعات کاربری زیر را
                            در اختیار مسئول مربوطه قرار دهید. بعد از بستن این
                            پنجره شما قادر به دیدن رمز عبور نخواهید بود.
                        </Alert>

                        <div>
                            <h3>نام کاربری:</h3>
                            <p className="pl-4">{this.state.newMemberUsername}</p>

                            <h3>رمز عبور:</h3>
                            <p className="pl-4">{this.state.newMemberPassword}</p>
                        </div>
                    </ModalBody>
                </Modal>

                
                <Modal isOpen={this.state.ChangePassModal} size="xlg" toggle={() => this.closeModal("ChangePassModal")}>
                    <ModalHeader toggle={() => this.closeModal("ChangePassModal")}>
                        تغییر رمز کاربری
                    </ModalHeader>
                    <ModalBody>
                        <ChangePassModal
                            UserName={this.state.UserName}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("ChangePassModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.DriverTurnModal} size="xlg" toggle={() => this.closeModal("DriverTurnModal")}>
                    <ModalHeader toggle={() => this.closeModal("DriverTurnModal")}>
                       
                    </ModalHeader>
                    <ModalBody>
                        <DriverTurnModal
                            IsAdmin={true}
                            LoadHallId={this.state.LoadHallId}
                            showSpinner={this.props.showSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("DriverTurnModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.DriverCityNativeModal} size="xlg" toggle={() => this.closeModal("DriverCityNativeModal")}>
                    <ModalHeader toggle={() => this.closeModal("DriverCityNativeModal")}>
                       
                    </ModalHeader>
                    <ModalBody>
                        <DriverCityNativeModal
                            IsAdmin={true}
                            LoadHallId={this.state.LoadHallId}
                            showSpinner={this.props.showSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            hideSpinner={this.props.hideSpinner}
                            showAlert={this.props.showAlert}
                            closeModal={this.closeModal}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => this.closeModal("DriverCityNativeModal")}>
                            انصراف
                        </Button>
                    </ModalFooter>
                </Modal>
                
            </>
        )
    }
}

export default LoadHalls;